import axios from "axios";

import {requiredHeaders} from "../../helpers/authservice/requiredHeaders";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "./log";
import {defineStore} from "pinia";
import {authHeader} from "@/helpers/authservice/auth-header";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


const reportsEndpoint = "/api/reports-manager/reports";
const reportsFilesEndpoint = "/api/reports-manager/files";
const settingsEndpoint = "/api/settings";

export const useReportsManagerModule = defineStore("reportsManagerModule", {


    state: () => ({
        lazyLoaderModule: useLazyLoaderModule(),
        //Common
        backendModuleName: "REPORTS",
        availableReportTypes: [],
        availableValueTypeMap: {
            1: "Liczba całkowita",
            2: "Liczba zmienno przecinkowa",
            3: "Tekst",
            4: "Data",
            5: "Czas",
            6: "Data i czas",
            7: "Prawda Fałsz",
        },
        //User data
        user: {},

        //Settings
        settings: [],

        //Reports (legacy)
        reports: [],
        reportsPagesCount: 0,
        reportsTotal: 0,
        reportDataRows: [],
        reportDataRowsPagesCount: 0,
        reportDataRowsTotal: 0,
        reportDataHeaders: [],

        // New reports manager list state
        reportsList: [],
        reportsListPagesCount: 0,
        reportsListTotal: 0,

        // Mocked chart state (to be replaced with real API when backend is ready)
        visualReportChart: null,
        visualReportChartData: null,
    }),
    getters: {
        //Common
        getBackendModuleName: (state) => state.backendModuleName,
        getAvailableReportTypes: (state) => state.availableReportTypes,
        getReportsManagerSettings: (state) => state.settings,

        //Reports (legacy)
        getReports: (state) => state.reports,
        getReportsPagesCount: (state) => state.reportsPagesCount,
        getReportsTotal: (state) => state.reportsTotal,
        getReportDataRows: (state) => state.reportDataRows,
        getReportDataRowsPagesCount: (state) => state.reportDataRowsPagesCount,
        getReportDataRowsTotal: (state) => state.reportDataRowsTotal,
        getReportDataHeaders: (state) => state.reportDataHeaders,

        // New reports manager list getters
        getReportsList: (state) => state.reportsList,
        getReportsListPagesCount: (state) => state.reportsListPagesCount,
        getReportsListTotal: (state) => state.reportsListTotal,

        // Mocked chart getters
        getVisualReportChart: (state) => state.visualReportChart,
        getVisualReportChartData: (state) => state.visualReportChartData,
    },
    actions: {
        // mutations
        setReportsManagerSettings(settings) {
            this.settings = settings;
        },

        //Reports (legacy)
        setReports(reports) {
            this.reports = reports;
        },
        setReportsPagesCount(pagesCount) {
            this.reportsPagesCount = pagesCount;
        },
        setReportsTotal(total) {
            this.reportsTotal = total;
        },
        setReportDataRows(reportDataRows) {
            this.reportDataRows = reportDataRows;
        },
        setReportDataRowsPagesCount(pagesCount) {
            this.reportDataRowsPagesCount = pagesCount;
        },
        setReportDataRowsTotal(total) {
            this.reportDataRowsTotal = total;
        },
        setReportDataHeaders(reportDataHeaders) {
            this.reportDataHeaders = reportDataHeaders;
        },

        // New reports manager list mutations
        setReportsList(reportsList) {
            this.reportsList = reportsList;
        },
        setReportsListPagesCount(pagesCount) {
            this.reportsListPagesCount = pagesCount;
        },
        setReportsListTotal(total) {
            this.reportsListTotal = total;
        },
        setAvailableReportTypes(types) {
            this.availableReportTypes = types;
        },
        // Mocked chart mutations
        setVisualReportChart(chart) {
            this.visualReportChart = chart;
        },
        setVisualReportChartData(data) {
            this.visualReportChartData = data;
        },
        // Actions
        // =================================================== new api for reports ================================================
        httpGetAllReports() {
            const endpoint = reportsEndpoint + "/pages/total";
            return axios
                .get(endpoint, {
                    headers: {
                        Authorization: authHeader(),
                    },
                    data: {},
                })
                .then((response) => {
                    log.log(response);
                    if (response.status === 200) {
                        this.setPackageOrdersPagesCount(response.data.payload);
                    } else if (response.status === 203) {
                        log.log(response);
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                });
        },

        httpGetAllReportsFilesCountForDrugstores( payload) {
            log.log(this.backendModuleName);
            var minutesBackwards = payload.minutesBackwards
            if (!minutesBackwards) {
                minutesBackwards = 0
            }
            var hoursBackwards = payload.hoursBackwards
            if (!hoursBackwards) {
                hoursBackwards = 0
            }
            var daysBackwards = payload.daysBackwards
            if (!daysBackwards) {
                daysBackwards = 0
            }


            var endpoint = reportsFilesEndpoint + "/count/drugstores?minutesBackwards=" + minutesBackwards + "&hoursBackwards=" + hoursBackwards + "&daysBackwards=" + daysBackwards;

            return axios
                .get(endpoint, {
                    headers: {
                        Authorization: authHeader(),
                    },
                    data: {},
                })
        },

        httpGetAllReportsFilesCountForDrugstore( payload) {
            log.log(this.backendModuleName);
            const drugstoreId = payload.drugstoreId
            var minutesBackwards = payload.minutesBackwards
            if (!minutesBackwards) {
                minutesBackwards = 0
            }
            var hoursBackwards = payload.hoursBackwards
            if (!hoursBackwards) {
                hoursBackwards = 0
            }
            var daysBackwards = payload.daysBackwards
            if (!daysBackwards) {
                daysBackwards = 0
            }


            var endpoint = reportsFilesEndpoint + "/count/drugstores/" + drugstoreId + "?minutesBackwards=" + minutesBackwards + "&hoursBackwards=" + hoursBackwards + "&daysBackwards=" + daysBackwards;

            return axios
                .get(endpoint, {
                    headers: {
                        Authorization: authHeader(),
                    },
                    data: {},
                })
        },


        //Settings
        httpGetReportsManagerSettings() {
            const endpoint = settingsEndpoint + "/module/" + this.backendModuleName;
            return axios({
                method: "get",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    if (response.status === 200) {
                        log.log("Displaying settings payload:");
                        log.log(response.data.payload);
                        this.setReportsManagerSettings(response.data.payload);
                    } else if (response.status === 203) {
                        log.log(response);
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                });
        },
        httpGetReportDataPaging( payload) {
            var reportType = payload.reportType;
            var reportGuid = payload.reportGuid;
            var pageNumber = payload.currentPage;
            var filterRequestObject = payload.searchAndFilterRequest;

            var endpoint_last_part = "/data/reportType/" + reportType + "/guid/" + reportGuid + "?page=";
            var endpoint = reportsEndpoint + endpoint_last_part + pageNumber;
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: filterRequestObject,
            })
                .then((response) => {
                    if (response.status === 200) {
                        this.setReportDataRowsPagesCount(response.data.payload.totalPages
                        );
                        this.setReportDataRowsTotal(response.data.payload.totalElements
                        );
                        this.setReportDataRows(response.data.payload.content);
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetReportDataPaging");
                });

        },

        httpGetReportHeaders( payload) {
            var reportType = payload.reportType;
            var endpoint = reportsEndpoint + "/headers/reportType/" + reportType;
            log.log("httpGetReportHeaders Required headers:");
            log.log(authHeader());
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            }).then((response) => {
                log.log("Fetching report data headers:");
                log.log(response);
                if (response.status === 200) {

                    log.log(response.data.payload);
                    this.setReportDataHeaders(response.data.payload);
                }
                return apiRequestsHelper.handleResponseWithDialogs(response, false);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetReportHeaders");
                });
        },

        // =================================================== New Reports Manager API ================================================

        httpGetReportsList(payload) {
            const page = payload.page || 1;
            var endpoint = reportsEndpoint + "/pages/all?page=" + page;
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: payload.searchAndFilterRequest || {},
            })
                .then((response) => {
                    if (response.status === 200) {
                        this.setReportsList(response.data.payload.content);
                        this.setReportsListPagesCount(response.data.payload.totalPages);
                        this.setReportsListTotal(response.data.payload.totalElements);
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetReportsList");
                });
        },

        httpGetAvailableReportTypes() {
            const endpoint = reportsEndpoint + "/types";
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    if (response.status === 200) {
                        this.setAvailableReportTypes(response.data.payload);
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetAvailableReportTypes");
                });
        },

        httpSyncReportsFromCentral() {
            const endpoint = reportsEndpoint + "/sync-from-central";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSyncReportsFromCentral");
                });
        },

        httpGenerateReport(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/generate";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGenerateReport");
                });
        },

        httpFetchDataFromDrugstores(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/fetch-data";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpFetchDataFromDrugstores");
                });
        },

        httpImportFetchedFiles(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/import-files";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpImportFetchedFiles");
                });
        },

        httpExportFullData(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/export-full-data";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpExportFullData");
                });
        },

        httpSendReportByEmail(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/send/email";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSendReportByEmail");
                });
        },

        httpSendReportByFtp(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/send/ftp";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSendReportByFtp");
                });
        },

        httpResetReportData(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/reset-data";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpResetReportData");
                });
        },

        httpCleanOldReportFiles(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/clean-old-files";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCleanOldReportFiles");
                });
        },

        httpDeleteReport(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid;
            return axios({
                method: "delete",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpDeleteReport");
                });
        },

        httpGetReportFolderInfo(reportGuid) {
            const endpoint = reportsEndpoint + "/" + reportGuid + "/folder-info";
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetReportFolderInfo");
                });
        },

        // =================================================== Report Form API ================================================

        httpGetDefaultReportConfig(reportType) {
            const endpoint = reportsEndpoint + "/form/default-config/" + reportType;
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetDefaultReportConfig");
                });
        },

        httpGetReportForEdit(reportGuid) {
            const endpoint = reportsEndpoint + "/form/" + reportGuid;
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetReportForEdit");
                });
        },

        httpCreateReport(dto) {
            return axios({
                method: "post",
                url: reportsEndpoint + "/form",
                headers: requiredHeaders(),
                data: dto,
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCreateReport");
                });
        },

        httpUpdateReport(reportGuid, dto) {
            const endpoint = reportsEndpoint + "/form/" + reportGuid;
            return axios({
                method: "put",
                url: endpoint,
                headers: requiredHeaders(),
                data: dto,
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateReport");
                });
        },

        httpSaveAndGenerateReport(reportGuid, dto) {
            const endpoint = reportsEndpoint + "/form/" + reportGuid + "/save-and-generate";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: dto,
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSaveAndGenerateReport");
                });
        },

        httpValidateReportName(name, existingGuid) {
            const endpoint = reportsEndpoint + "/form/validate-name";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: { name: name, existingGuid: existingGuid || null },
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpValidateReportName");
                });
        },

        httpValidateReportConfig(dto) {
            const endpoint = reportsEndpoint + "/form/validate-config";
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: dto,
            })
                .then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpValidateReportConfig");
                });
        },



    },
});


